module.exports = __webpack_public_path__ + "media/images/webpage/logo/logo-bushikaku-icotto-926aaf809ed017fa3be9a0b61968eedb.svg";